var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paddingLR"},[_c('location-logo'),_c('location-info')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }